import { render, staticRenderFns } from "./DateTimeRangeConfig.vue?vue&type=template&id=3c9b4972&scoped=true"
import script from "./DateTimeRangeConfig.vue?vue&type=script&lang=js"
export * from "./DateTimeRangeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b4972",
  null
  
)

export default component.exports